module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav_menu_wrapper"
  }, [_c('nav', {
    staticClass: "nav-menu",
    class: {
      small: _vm.searchIsFocused
    }
  }, [_vm._t("menu", [_c('main-nav', {
    attrs: {
      "items": _vm.localItems,
      "max-level": _vm.menuMaxLevel,
      "small": _vm.searchIsFocused
    }
  })])], 2), _c('div', {
    staticClass: "nav-search",
    class: {
      wide: _vm.searchIsFocused
    }
  }, [_vm._t("search", [(_vm.searchIsFocused || !_vm.hasMenuItems) ? _c('main-search', {
    attrs: {
      "target": _vm.searchTarget,
      "field-name": _vm.searchName,
      "field-value": _vm.searchValue,
      "has-focus": _vm.hasMenuItems
    },
    on: {
      "submit": _vm.onSubmit,
      "blur": function($event) {
        return _vm.onFocusSearch(false)
      },
      "focus": function($event) {
        return _vm.onFocusSearch(true)
      }
    }
  }) : _c('AppSvgIconNew', {
    staticClass: "search_glass ui_icon_stroke_transparent nav_svg_icon",
    attrs: {
      "as-is-button": "as-is-button",
      "template": _vm.$ui.IconSvgComponents.searchGlass,
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.searchIsFocused = !_vm.searchIsFocused
      }
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b53899c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/header/Nav.vue
// module id = 3cda72943a9f089cabff
// module chunks = 7